import { CommonModule } from '@angular/common'
import {CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule, NO_ERRORS_SCHEMA} from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { BrowserModule } from '@angular/platform-browser'
import { AmplifyAuthenticatorModule } from '@aws-amplify/ui-angular'
import { AutocompleteLibModule } from 'angular-ng-autocomplete'
import { RECAPTCHA_LANGUAGE, RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from "ng-recaptcha"
import { PARAMS } from './PARAMS'
import { AmplifyLoginComponent } from './amplify-login/amplify-login.component'
import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { ChangePswComponent } from './change-psw/change-psw.component'
import { LoginComponent } from './login/login.component'
import { LogoutComponent } from './logout/logout.component'
import { MfaComponent } from './mfa/mfa.component'
import { ProfileComponent } from './profile/profile.component'
import { ModalModule } from 'ngx-bootstrap/modal'
import { EmailValidatorCodeComponent } from './email-validator-code/email-validator-code.component'
import {AltResetPswComponent} from "./alt-reset-psw/alt-reset-psw.component";
import {AddUserComponent} from "./add-user/add-user.component";
import {LinkSchoolComponent} from "./link-school/link-school.component";
import {ValidateUserComponent} from "./validate-user/validate-user.component";
import {AddUserWrapperComponent} from "./add-user/add-user-wrapper/add-user-wrapper.component";

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    LogoutComponent,
    MfaComponent,
    AmplifyLoginComponent,
    ChangePswComponent,
    ProfileComponent,
    EmailValidatorCodeComponent,
    AltResetPswComponent,
    AddUserComponent,
    AddUserWrapperComponent,
    ValidateUserComponent,
    LinkSchoolComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CommonModule,
    FormsModule,
    AmplifyAuthenticatorModule,
    ReactiveFormsModule,
    AutocompleteLibModule,
    RecaptchaV3Module,
    ModalModule.forRoot(),
  ],
  providers: [
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: PARAMS.RECAPTCHA },
    { provide: LOCALE_ID, useValue: 'nl-BE' },
    {
      provide: RECAPTCHA_LANGUAGE,
      useFactory: (locale: string) => locale,
      deps: [LOCALE_ID],
    },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
